import React, { useState, useEffect } from "react";
import "../styles/NavbarStyles.css";
import "../styles/GlobalStyles.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const NAV_ITEMS = [
  { name: "Welcome", path: "/" },
  { name: "About", path: "/about" },
  {
    name: "Portfolio",
    path: "https://www.instagram.com/afterglobeautyco/",
    external: true
  },
  { name: "Services", path: "/services" },
  { name: "Education", path: "/education" },
  { name: "Contact", path: "/contact" }
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location]);

  // Prevent body scroll when menu open on mobile
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <nav className="nav-root">
      <span className="nav-brand" onClick={() => navigate("/")}>
        Afterglo Beautyco
      </span>

      <button
        className="nav-toggle"
        aria-label={open ? "Close menu" : "Open menu"}
        onClick={() => setOpen((o) => !o)}
      >
        {open ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      <div className={`nav-overlay${open ? " open" : ""}`}>
        {NAV_ITEMS.map((item) =>
          item.external ? (
            <a
              key={item.name}
              href={item.path}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
            >
              {item.name}
            </a>
          ) : (
            <NavLink
              key={item.name}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
            >
              {item.name}
            </NavLink>
          )
        )}
      </div>
    </nav>
  );
};

export default Navbar;
